<template>
    <div class="city-contain" :class="className">
        <div v-if="selfItem.city_id" class="city-box bg">
            <div class="city-id">{{selfItem.index}}</div>
            <div class="right-box">
                <div class="line-box">
                    <div
                        class="city-name"
                        :style="{width:maxWidth}"
                    >{{selfItem.cityShortName}}&#160;</div>
                    <!-- <div class="line" :style="'width:' + (selfItem.count / maxLine) * 100 + '%'"></div> -->
                </div>
                <div class="mark">{{selfItem.count}}</div>
                <div
                    class="rank-box"
                    :class="tabIndex > 0?'down' : 'up'"
                    v-if="selfItem.tIndex - selfItem.lastIndex > 0"
                >- {{selfItem.tIndex - selfItem.lastIndex}} ↓</div>
                <div
                    class="rank-box"
                    :class="tabIndex > 0?'up' : 'down'"
                    v-if="selfItem.tIndex - selfItem.lastIndex < 0"
                >+ {{selfItem.lastIndex - selfItem.tIndex}} ↑</div>
                <div class="rank-box fair" v-if="selfItem.tIndex-selfItem.lastIndex === 0">持平</div>
            </div>
        </div>
        <div v-for="(item, index) in rankList" :key="index">
            <div v-if="showAll || index < firstSize" class="city-box line_bottom">
                <div class="city-id">{{index + 1}}</div>
                <div class="right-box">
                    <div class="line-box">
                        <div
                            class="city-name"
                            :style="{width:maxWidth}"
                        >{{item.cityShortName}}&#160;</div>
                        <!-- <div class="line" :style="'width:' + (item.count / maxLine) * 100 + '%'"></div> -->
                    </div>
                    <div class="mark">{{item.count}}</div>
                    <div
                        class="rank-box"
                        :class="tabIndex > 0?'down' : 'up'"
                        v-if="tList[Number(item.city_id)].index - lastList[Number(item.city_id)].index > 0"
                    >- {{tList[Number(item.city_id)].index-lastList[Number(item.city_id)].index}} ↓</div>
                    <div
                        class="rank-box"
                        :class="tabIndex > 0?'up' : 'down'"
                        v-if="tList[Number(item.city_id)].index-lastList[Number(item.city_id)].index < 0"
                    >+ {{lastList[Number(item.city_id)].index-tList[Number(item.city_id)].index}} ↑</div>
                    <div
                        class="rank-box fair"
                        v-if="tList[Number(item.city_id)].index-lastList[Number(item.city_id)].index === 0"
                    >持平</div>
                </div>
            </div>
            <!-- <rline v-if="index !== rankList.length-1"></rline> -->
        </div>
        <div class="more-box" @click="handleShowAll" v-if="!showAll && rankList.length > firstSize">
            <span>展开所有排名</span>
            <img src="../../../assets/guideSystem/show_more.png" />
        </div>
        <div
            class="more-box"
            @click="handleShowAll(false)"
            v-if="showAll && rankList.length > firstSize"
        >
            <span>收起所有排名</span>
            <img src="../../../assets/guideSystem/shouqi_up.png" />
        </div>
    </div>
</template>

<script>
    import rline from '../../travelAgency/components/line';
    export default {
        name: 'guideRankCharts',
        components: {
            rline
        },
        props: {
            rankList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            firstSize: {
                type: Number,
                default: () => {
                    return 5;
                }
            },
            selfId: {
                type: Number,
                default: () => {
                    return 0;
                }
            },
            unit: {
                type: String,
                default: '位'
            },
            className: {
                type: String,
                default: 'default'
            },
            indexKey: {
                type: String,
                default: ''
            },
            tabIndex: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                showAll: false,
                lastList: [],
                tList: []
            // selfItem: {}
            };
        },
        computed: {
            maxWidth () {
                let max = 0;
                let nameArry = [];
                this.rankList.forEach(item => {
                    nameArry.push(item.cityShortName);
                });
                if (nameArry.length > 0) {
                    var longest = nameArry.sort(function (a, b) {
                        return b.length - a.length;
                    })[0];
                    max = longest.length * 18.5;
                    return max > 30 ? max + 'px' : '30px';
                } else {
                    return '30px';
                }
            },
            maxLine () {
                this.handleShowAll(false);
                return this.rankList[0].count || 0;
            },
            selfItem () {
                this.handleShowAll(false);
                this.sortList(this.rankList);
                let tmpItem = {};
                this.rankList.forEach((item, index) => {
                    let obj = JSON.parse(JSON.stringify(item));
                    if (
                        Number(obj.city_id) === Number(this.selfId) &&
                        Number(obj.city_id) > 0
                    ) {
                        obj.index = index + 1;
                        let last = JSON.parse(
                            JSON.stringify(this.lastList[Number(obj.city_id)].index)
                        );
                        obj.lastIndex = last + 1;
                        let tItem = JSON.parse(
                            JSON.stringify(this.tList[Number(obj.city_id)].index)
                        );
                        obj.tIndex = tItem + 1;
                        // obj.index = obj.tIndex;
                        // tmpItem.count = tmpItem.currentCount
                        tmpItem = obj;
                    }
                });
                if (this.selfId > 0) {
                    this.$emit('setSelfItem', this.indexKey, tmpItem);
                }
                return tmpItem;
            }
        },
        mounted () {},
        methods: {
            handleShowAll (state = true) {
                this.showAll = state;
            },
            sortList (list) {
                list.sort((x, y) => {
                    return y.count - x.count;
                });
                let lastList = JSON.parse(JSON.stringify(list));
                let tList = JSON.parse(JSON.stringify(list));
                lastList.sort((x, y) => {
                    return y.previousCount - x.previousCount;
                });
                let arr = {};
                lastList.forEach((item, key) => {
                    item.index = key;
                    arr[Number(item.city_id)] = item;
                });
                this.lastList = arr;
                // tList.sort((x, y) => {
                //     return y.currentCount - x.currentCount
                // })
                arr = {};
                tList.forEach((item, key) => {
                    item.index = key;
                    arr[Number(item.city_id)] = item;
                });
                this.tList = arr;
                console.log(lastList);
                console.log(tList);
                console.log(this.lastList);
                console.log(this.tList);
                return list;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain {
    width: 100%;
    height: 100%;
    &.fixed-height {
        height: 250px;
        overflow-y: scroll;
    }
    &.default {
        display: flex;
        flex-direction: column;
    }
    .city-box {
        padding-left: 12px;
        padding-right: 12px;
        // border-bottom: 1px solid #eeeeee;
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        &.bg {
            background: rgba(54, 179, 116, 0.2);
            box-shadow: 0px 0px 0px 0px rgba(238, 238, 238, 1);
            .city-id {
                color: #36b374;
            }
        }
        .city-id {
            width: 23px;
            color: #333333;
            font-size: 14px;
            line-height: 14px;
            margin-right: 6px;
            font-weight: bold;
            font-family: PingFangSC-Regular, PingFang SC;
            -webkit-font-smoothing: antialiased;
        }
        .city-name {
            display: flex;
            justify-content: flex-start;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 10px;
            white-space: nowrap;
            // margin-top: 12px;
            // margin-bottom: 8px;
        }
        .right-box {
            // margin-left: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            .line-box {
                display: flex;
                flex-direction: column;
                height: 50px;
                // align-items: center;
                justify-content: space-around;
                width: 100%;
                .line {
                    height: 6px;
                    background: #36b374;
                }
            }
            .mark {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 10px;
                margin-left: 12px;
                white-space: nowrap;
                margin-right: 40px;
            }

            .rank-box {
                width: 60px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                text-align: center;
                color: #2283e6;
                &.fair {
                    font-size: 10px;
                }
                &.up {
                    color: #36b374;
                }

                &.down {
                    color: #ff4d4d;
                }
            }
        }
    }
    .more-box {
        height: 49px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #9b9b9b;
        img {
            height: 4px;
            width: 7px;
            margin-left: 3px;
        }
        span {
            height: 49px;
            line-height: 49px;
            display: block;
        }
    }
}
</style>
